import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/left.svg';

export const IconLeft = createIconComponent(Icon);
